// @flow
import React, { PureComponent } from 'react';
import type { EventType, EventMatchType } from 'types/Event';
import EventListElementWrapper from 'components/event/EventListElementWrapper';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  events: Array<EventType | EventMatchType>,
  forceOpen?: boolean,
  areHiddenMatches?: boolean,
};

type State = {
  isOpen: boolean
};

class HiddenEventListElement extends PureComponent<Props, State> {
  static defaultProps = {
    areHiddenMatches: false,
  };

  props: Props;
  state: State = {
    isOpen: false
  };

  componentDidUpdate(prevProps: Props) {
    if (this.props.forceOpen !== prevProps.forceOpen) {
      this.setState(({ isOpen: prevIsOpen }) => ({ isOpen: !prevIsOpen }));
    }
  }

  handleHiddenMenuClicked = (e: MouseEvent) => {
    e.preventDefault();
    this.setState(({ isOpen: prevIsOpen }) => ({ isOpen: !prevIsOpen }));
  };

  renderEvents = (): any => {
    const { events } = this.props;
    return events.map((event, index) => (
      <EventListElementWrapper key={`${String(event.startDate)}${index}`} event={events[index]} />
    ));
  };

  render() {
    const { areHiddenMatches } = this.props;
    const { isOpen } = this.state;

    const classNamesContainer = dynamicClassName('accordion-panel');
    !isOpen && classNamesContainer.add('is-hidden');

    const classNamesTrigger = dynamicClassName(
      'link-chevron link-chevron--block link-chevron--center link-chevron--inline accordion-trigger'
    );
    isOpen && classNamesTrigger.add('is-selected');
    const wording = areHiddenMatches ? 'Voir tous les matchs' : 'Voir tous les évènements';
    return (
      <>
        <div className={classNamesContainer.build()}>{this.renderEvents()}</div>
        <a // eslint-disable-line
          onClick={this.handleHiddenMenuClicked}
          role="button"
          tabIndex={0}
          title={isOpen ? 'Moins' : 'Plus'}
          className={classNamesTrigger.build()}
        >
          <span>{wording}</span>
          <i className="icon icon-zoom_plus" />
        </a>
      </>
    );
  }
}

export default HiddenEventListElement;
